"use client";

import { TooltipProvider } from "@/components/ui/tooltip";
import type { SessionRecord } from "@/lib/api";
import { SESSION_COLUMNS, type SessionColumn, type SessionColumnKey } from "@/lib/session-columns";

interface SessionTableProps {
  sessions: SessionRecord[];
  columnKeys: readonly SessionColumnKey[];
  onOpenRow: (id: string) => void;
  loading?: boolean;
  emptyLabel?: string;
}

export function SessionTable({
  sessions,
  columnKeys,
  onOpenRow,
  loading = false,
  emptyLabel = "暂无会话",
}: SessionTableProps) {
  const cols: SessionColumn[] = columnKeys.map((k) => SESSION_COLUMNS[k]);

  return (
    <TooltipProvider delayDuration={200}>
      <table className="w-full text-sm">
        <thead className="sticky top-0 border-b bg-background">
          <tr className="text-left text-xs text-muted-foreground">
            {cols.map((c) => (
              <th
                key={c.key}
                className={`px-3 py-2 font-medium ${c.align === "right" ? "text-right" : ""}`}
              >
                {c.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={cols.length} className="px-4 py-8 text-center text-muted-foreground">
                加载中...
              </td>
            </tr>
          ) : sessions.length === 0 ? (
            <tr>
              <td colSpan={cols.length} className="px-4 py-8 text-center text-muted-foreground">
                {emptyLabel}
              </td>
            </tr>
          ) : (
            sessions.map((s) => (
              <tr key={s.session_id} className="border-b hover:bg-muted/50">
                {cols.map((c) => (
                  <td
                    key={c.key}
                    className={`px-3 py-2 ${c.align === "right" ? "text-right" : ""}`}
                  >
                    {c.render(s, { onOpenRow })}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </TooltipProvider>
  );
}
